import React, { ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { useMobile } from '../mobile/mobile.provider';
import classNames from 'classnames';

type Props = {
  label?: string;
  children: ReactNode;
};
function ContextSelectorMenu({ label, children }: Props) {
  const dropdownRef = useRef(null);
  const [left, setLeft] = useState(0);
  const { isMobile } = useMobile();

  useLayoutEffect(() => {
    const adjustPosition = () => {
      const dropdown = dropdownRef.current;
      if (dropdown) {
        const rect = dropdown.getBoundingClientRect();
        if (rect.left > 0) {
          setLeft(-rect.left);
        }
      }
    };

    if (isMobile) {
      adjustPosition();
      window.addEventListener('resize', adjustPosition);
    }

    return () => window.removeEventListener('resize', adjustPosition);
  }, []);

  return (
    <div
      ref={dropdownRef}
      data-test-id="dropdown"
      className={classNames('absolute left-0 top-full z-100', { 'mt-2 w-screen': isMobile, 'mt-1': !isMobile })}
      style={{ minWidth: '100%', left: isMobile ? `${left}px` : '0px' }}
    >
      <div className="bg-white rounded border border-light shadow-lg">
        {label && <div className="text-xs font-bold px-3 py-1 border-b border-light">{label}</div>}
        {children}
      </div>
    </div>
  );
}

export { ContextSelectorMenu };
